import React from "react";

type ListItemProps = {
  title?: string,
  subtitle?: string,
  caption?: string,
  style?: React.CSSProperties,
  active?: boolean,
  onClick: () => void
}

export default function ListItem(props: ListItemProps) {
  return (
    <div className={`listItem ${props.active ? "active" : ""}`} style={props.style} onClick={props.onClick}>
      { props.title && <div className={"listItem--title"}>{props.title}</div> }
      { props.subtitle && <div className={"listItem--subtitle"}>{props.subtitle}</div> }
      { props.caption && <div className={"listItem--caption"}>{props.caption}</div> }
    </div>
  );
}
